import React from 'react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import { DateTimePicker } from 'react-widgets';
import { Form, Divider, Header, Segment, Button, Input, Icon, Popup, Transition, Loader, Radio } from 'semantic-ui-react';

import LeasesTable from './Leases/LeasesTable';
import LeasesDetails from './Leases/LeasesDetails';
import LeasesFilter from './Leases/LeasesFilter';
import PaginationSegment from './util/PaginationSegment';
import ResultsPerPageDropdown from './util/ResultsPerPageDropdown';
import { fetchActiveRole, fetchUserOrganizationalUnit } from './util/roles';
import { fetchOrganizationalUnits, fetchLegalDocumentTypes } from './Lookups/util';
import { IconHeader, FiltersOnStyle } from './util/css';
import { getTotalNumberOfPages, checkOrganizationalUnitsPrivilege, checkFaculty, checkWritePrivilege, formatListForDropdownOptions, DEFAULT_NUMBER_OF_ITEMS_PER_PAGE } from './util/util';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

class Leases extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            organizationalUnits: [],
            organizationalUnitId: null,
            activeRole: null,

            leases: [],
            filteredLeases: [],

            legalDocumentTypes: [],
            leaseholders: [],
            properties: [],

            // Form data
            leaseholder: null,
            property: null,
            startDate: new Date(),
            endDate: new Date(),
            monthlyIncome: null,
            comment: null,
            isInsideUniversity: null,
            purpose: null,

            // Document form data
            documentType: null,
            documentDate: new Date(),
            documentNumber: null,
            documentComment: null,
            documentId: null,
            documentOptLock: null,

            leaseId: null,
            leaseOptLock: null,

            // Component behaviour
            requestMode: null,
            loading: true,
            showFiltersOnButton: false,
            showFilterMode: false,
            startDatePicked: false,
            endDatePicked: false,
            leaseholderSelected: null,
            propertySelected: null,

            // For details
            details: false,
            leaseObject: null,

            // For required fields
            hasLegalDocument: false,
            leaseholderError: false,
            propertyError: false,
            startDateError: false,
            endDateError: false,
            monthlyIncomeError: false,
            documentTypeError: false,
            documentDateError: false,
            documentNumberError: false,

            // For pagination
            activePage: 1,
            totalPages: 1,
            resultsPerPage: DEFAULT_NUMBER_OF_ITEMS_PER_PAGE,
            filterRequestData: null,

            // For sorting, default values
            fieldName: null,
            fieldProperty: null,
            direction: null,
        };

        this.affirmation = [
            {
                key: 0,
                value: 0,
                text: 'Da',
            },
            {
                key: 1,
                value: 1,
                text: 'Ne',
            }
        ];

        this.handleInputChange = this.handleInputChange.bind(this);
        this.activateEditRequest = this.activateEditRequest.bind(this);
        this.activateAddRequest = this.activateAddRequest.bind(this);
        this.populateValues = this.populateValues.bind(this);
        this.cancelRequest = this.cancelRequest.bind(this);
        this.putLease = this.putLease.bind(this);

        this.activateFilter = this.activateFilter.bind(this);
        this.onFilterData = this.onFilterData.bind(this);
        this.filtersOff = this.filtersOff.bind(this);
        this.getDataToRender = this.getDataToRender.bind(this);

        this.fetchLookups = this.fetchLookups.bind(this);
        this.fetchDataForRole = this.fetchDataForRole.bind(this);
        this.handleLeaseholderInputChange = this.handleLeaseholderInputChange.bind(this);
        this.getProperties = this.getProperties.bind(this);

        this.switchToDetails = this.switchToDetails.bind(this);
        this.switchToTable = this.switchToTable.bind(this);
        this.handleToggleLegalDocumentChange = this.handleToggleLegalDocumentChange.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
        this.handleResultsPerPageChange = this.handleResultsPerPageChange.bind(this);
        this.getSortedLeases = this.getSortedLeases.bind(this);
    }

    componentWillMount() {
        this.getUserData();
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
    }

    getUserData() {
        axios.all([fetchActiveRole(), fetchUserOrganizationalUnit()])
            .then(axios.spread((activeRoleRes, userOrganizationalUnitRes) => {
                const activeRole = activeRoleRes.data;
                const organizationalUnitId = userOrganizationalUnitRes.data === '' ? null : userOrganizationalUnitRes.data;

                this.fetchLookups(activeRole, organizationalUnitId);
            }))
            .catch(err => {
                this.setState({ error: true, loading: false });
                console.log('Failed to fetch data.');
            });
    }

    fetchLookups(activeRole, organizationalUnitId) {
        this.fetchDataForRole(activeRole, organizationalUnitId);
    }

    fetchDataForRole(activeRole, organizationalUnitId) {
        if (checkOrganizationalUnitsPrivilege(activeRole)) {
            axios.all([fetchOrganizationalUnits(), this.fetchAllLeases(), this.fetchOrganizationalUnitProperties(), this.fetchLeaseholders(), fetchLegalDocumentTypes()])
                .then(axios.spread((organizationalUnitsRes, leasesRes, propertiesRes, leaseholdersRes, documentTypesRes) => {
                    const organizationalUnits = formatListForDropdownOptions(organizationalUnitsRes.data);
                    const leases = leasesRes.data.responseList.map(el => ({
                        ...el, beginDate: new Date(el.dateStart), endDate: new Date(el.dateEnd),
                    }));

                    const properties = propertiesRes.data.map(el => ({
                        ...el, key: el.id, value: el.id, text: el.property.name,
                    }));

                    const leaseholders = leaseholdersRes.data.map(el => ({
                        ...el,
                        key: el.id,
                        value: el.id,
                        text: this.getLeaseholderName(el),
                    }));

                    const legalDocumentTypes = documentTypesRes.data.map(el => ({
                        ...el, key: el.id, value: el.id, text: el.name
                    }));

                    let totalPages = getTotalNumberOfPages(leasesRes.data.total, DEFAULT_NUMBER_OF_ITEMS_PER_PAGE);
                    this.setState({
                        organizationalUnits,
                        leases,
                        properties,
                        leaseholders,
                        legalDocumentTypes,
                        totalPages,
                        loading: false,
                        activeRole,
                        organizationalUnitId,
                    });
                }))
                .catch(err => {
                    this.setState({ error: true, loading: false });
                    console.log('Failed to fetch data.');
                    console.log(err);
                });
        } else if (checkFaculty(activeRole)) {
            axios.all([this.fetchFacultyLeases(), this.fetchFacultyLeaseholders(), this.fetchFacultyOrganizationalUnitProperties(), fetchLegalDocumentTypes()])
                .then(axios.spread((leasesRes, leaseholdersRes, propertiesRes, documentTypesRes) => {
                    const leases = leasesRes.data.responseList.map(el => ({
                        ...el, beginDate: new Date(el.dateStart), endDate: new Date(el.dateEnd),
                    }));

                    const properties = propertiesRes.data.map(el => ({
                        ...el, key: el.id, value: el.id, text: el.property.name,
                    }));

                    const leaseholders = leaseholdersRes.data.map(el => ({
                        ...el,
                        key: el.id,
                        value: el.id,
                        text: this.getLeaseholderName(el),
                    }));

                    const legalDocumentTypes = documentTypesRes.data.map(el => ({
                        ...el, key: el.id, value: el.id, text: el.name
                    }));

                    let totalPages = getTotalNumberOfPages(leasesRes.data.total, DEFAULT_NUMBER_OF_ITEMS_PER_PAGE);
                    this.setState({
                        leases,
                        properties,
                        leaseholders,
                        legalDocumentTypes,
                        totalPages,
                        loading: false,
                        activeRole,
                        organizationalUnitId,
                    });
                }))
                .catch(err => {
                    this.setState({ error: true, loading: false });
                    console.log('Failed to fetch data.');
                    console.log(err);
                });
        }
    }

    fetchAllLeases(page = 0, resultsPerPage = DEFAULT_NUMBER_OF_ITEMS_PER_PAGE) {
        const pagination = {
            page,
            resultsPerPage,
        };
        return axios.post('/assets/leases/all/', { ...pagination });
    }

    fetchFacultyLeases(page = 0, resultsPerPage = DEFAULT_NUMBER_OF_ITEMS_PER_PAGE) {
        const pagination = {
            page,
            resultsPerPage,
        };
        return axios.post('/assets/leases/paginated/', { ...pagination });
    }

    fetchOrganizationalUnitProperties(page = 0, resultsPerPage = DEFAULT_NUMBER_OF_ITEMS_PER_PAGE) {
        return axios.get('/assets/organizational-unit-properties/all/');
    }

    fetchLeaseholders(page = 0, resultsPerPage = DEFAULT_NUMBER_OF_ITEMS_PER_PAGE) {
        return axios.get('/assets/leaseholders/all/');
    }

    fetchFacultyLeaseholders() {
        return axios.get('/assets/leaseholders/');
    }

    fetchFacultyOrganizationalUnitProperties() {
        return axios.get('/assets/organizational-unit-properties/');
    }

    getLeases(page, resultsPerPage, sortingDTO = null) {
        const {
            activeRole, fieldName, fieldProperty, direction
        } = this.state;
        const pagination = {
            page,
            resultsPerPage,
            fieldName: sortingDTO ? sortingDTO.fieldName : fieldName,
            fieldProperty: sortingDTO ? sortingDTO.fieldProperty : fieldProperty,
            order: sortingDTO ? sortingDTO.direction === 'ascending' : direction ? direction === 'ascending' : null,
        };
        if (checkOrganizationalUnitsPrivilege(activeRole)) {
            axios.post('/assets/leases/all/', { ...pagination })
                .then(res => {
                    this.updateLeases(page, resultsPerPage, res, sortingDTO);
                })
                .catch(err => {
                    toast('Došlo je do greške!');
                });
        } else if (checkFaculty(activeRole)) {
            axios.post('/assets/leases/paginated/', { ...pagination })
                .then(res => {
                    this.updateLeases(page, resultsPerPage, res, sortingDTO);
                })
                .catch(err => {
                    toast('Došlo je do greške!');
                });
        }
    }

    getFilteredLeases(page, resultsPerPage, sortingDTO = null) {
        const {
            fieldName, fieldProperty, direction
        } = this.state;
        const paginationDTO = {
            page,
            resultsPerPage,
            fieldName: sortingDTO ? sortingDTO.fieldName : fieldName,
            fieldProperty: sortingDTO ? sortingDTO.fieldProperty : fieldProperty,
            order: sortingDTO ? sortingDTO.direction === 'ascending' : direction ? direction === 'ascending' : null,
        };
        let { filterRequestData } = this.state;
        filterRequestData = { ...filterRequestData, paginationDTO };

        axios.post('/assets/leases/filter/', { ...filterRequestData })
            .then(res => {
                this.updateLeases(page, resultsPerPage, res, sortingDTO, true);
            })
            .catch(err => {
                console.log('Failed to fetch filter results', err);
                toast('Doslo je do greške prilikom filtriranja!');
            });
    }

    getSortedLeases(fieldName, fieldProperty = null) {
        const sortingDTO = {
            direction: (this.state.fieldName === fieldName ? (this.state.direction === 'ascending' ? 'descending' : 'ascending') : 'ascending'),
            fieldName,
            fieldProperty,
        };

        if (!this.state.showFiltersOnButton) {
            this.getLeases(this.state.activePage - 1, this.state.resultsPerPage, sortingDTO);
        } else {
            this.getFilteredLeases(this.state.activePage - 1, this.state.resultsPerPage, sortingDTO);
        }
    }

    updateLeases(page, resultsPerPage, res, sortingDTO, filtersOn = false) {
        const leases = res.data.responseList.map(el => ({
            ...el, beginDate: new Date(el.dateStart), endDate: new Date(el.dateEnd),
        }));

        let totalPages = getTotalNumberOfPages(res.data.total, resultsPerPage);
        this.setState(prevState => ({
            leases: filtersOn ? [] : leases,
            filteredLeases: filtersOn ? leases : [],
            totalPages,
            activePage: page + 1,
            resultsPerPage,
            fieldName: sortingDTO ? sortingDTO.fieldName : prevState.fieldName,
            fieldProperty: sortingDTO ? sortingDTO.fieldProperty : prevState.fieldProperty,
            direction: sortingDTO ? (sortingDTO.fieldName === prevState.fieldName ? (prevState.direction === 'ascending' ? 'descending' : 'ascending') : 'ascending') : prevState.direction,
        }));
    }

    onFilterData(leasesFilter) {
        const { activeRole, resultsPerPage } = this.state;
        let leasesFilterRequest = {
            ...leasesFilter,
            paginationDTO: {
                page: 0,
                resultsPerPage,
            },
        };

        if (checkFaculty(activeRole)) {
            leasesFilterRequest = { ...leasesFilterRequest, organizationalUnit: this.state.organizationalUnitId };
        }

        axios.post('/assets/leases/filter/', { ...leasesFilterRequest })
            .then(res => {
                const filterData = res.data.responseList.map(el => ({
                    ...el, beginDate: new Date(el.dateStart), endDate: new Date(el.dateEnd),
                }));

                let totalPages = getTotalNumberOfPages(res.data.total, resultsPerPage);
                this.setState({
                    filteredLeases: filterData,
                    leases: [],
                    showFiltersOnButton: true,
                    showFilterMode: false,
                    activePage: 1,
                    totalPages,
                    filterRequestData: leasesFilterRequest,
                });
            })
            .catch(err => {
                console.log('Failed to fetch filter results', err);
                toast('Doslo je do greške prilikom filtriranja!');
            });
    }

    getDataToRender() {
        if (this.state.showFiltersOnButton) {
            return this.state.filteredLeases;
        }
        return this.state.leases;
    }

    getLeaseholderName(el) {
        if (el.entityType.id === 1) {
            return (el.physicalEntity.firstName + ' ' + el.physicalEntity.lastName);
        } else if (el.entityType.id === 2) {
            return el.legalEntity.name;
        }
        return el.organizationalUnitLeaseholder.name;
    }

    activateEditRequest(el) {
        this.setState({
            requestMode: 'edit',
            leaseholderError: false,
            propertyError: false,
            startDateError: false,
            endDateError: false,
            monthlyIncomeError: false,
            documentTypeError: false,
            documentDateError: false,
            documentNumberError: false,
        });
        this.populateValues(el);
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }

    activateAddRequest() {
        this.resetValues();
        this.setState({
            requestMode: 'add',
        });
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }

    cancelRequest() {
        this.setState({ requestMode: null });
        this.resetValues();
    }

    activateFilter() {
        this.setState({ showFilterMode: !this.state.showFilterMode });
    }

    filtersOff() {
        this.getLeases(0, this.state.resultsPerPage);

        this.setState({
            showFilterMode: false,
            showFiltersOnButton: false,
        });
    }

    resetValues() {
        this.setState({
            leaseholder: null,
            property: null,
            startDate: new Date(),
            endDate: new Date(),
            monthlyIncome: null,
            comment: null,
            isInsideUniversity: null,
            purpose: null,

            leaseId: null,
            leaseOptLock: null,

            documentType: null,
            documentDate: new Date(),
            documentNumber: null,
            documentComment: null,
            documentId: null,
            documentOptLock: null,

            startDatePicked: false,
            endDatePicked: false,

            hasLegalDocument: false,
            leaseholderError: false,
            propertyError: false,
            startDateError: false,
            endDateError: false,
            monthlyIncomeError: false,
            documentTypeError: false,
            documentDateError: false,
            documentNumberError: false,
        });
    }

    populateValues(el) {
        this.setState({
            leaseholder: el.leaseholder.id,
            property: el.organizationalUnitProperty.id,
            startDate: new Date(el.dateStart),
            endDate: new Date(el.dateEnd),
            monthlyIncome: el.incomePerMonth,
            comment: el.comment,
            purpose: el.purpose,
            leaseId: el.id,
            leaseOptLock: el.optLock,
            hasLegalDocument: false,
        });

        if (el.legalDocument !== null) {
            this.setState({
                documentType: el.legalDocument.legalDocumentType.id,
                documentDate: new Date(el.legalDocument.date),
                documentNumber: el.legalDocument.documentNumber,
                documentComment: el.legalDocument.comment,
                documentId: el.legalDocument.id,
                documentOptLock: el.legalDocument.optLock,
                hasLegalDocument: true,
            });
        }
    }

    sendLeaseRequest() {
        const {
            property, leaseholder, startDate, endDate, monthlyIncome,
            documentType, documentDate, documentNumber, hasLegalDocument
        } = this.state;

        if (property === null || leaseholder === null || startDate === null || endDate === null ||
            monthlyIncome === null || (documentType === null && hasLegalDocument) ||
            (documentNumber === null && hasLegalDocument) || (documentDate === null && hasLegalDocument)) {
            this.setState({
                leaseholderError: leaseholder === null,
                propertyError: property === null,
                startDateError: startDate === null,
                endDateError: endDate === null,
                monthlyIncomeError: monthlyIncome === null,
                documentTypeError: (documentType === null && hasLegalDocument),
                documentDateError: (documentDate === null && hasLegalDocument),
                documentNumberError: (documentNumber === null && hasLegalDocument),
            });

            toast('Nisu sva potrebna polja popunjena!');
            return;
        }

        let leaseRequest = {
            organizationalUnitProperty: { id: this.state.property },
            comment: this.state.comment,
            leaseholder: { id: this.state.leaseholder },
            dateStart: this.state.startDate.getTime(),
            dateEnd: this.state.endDate.getTime(),
            incomePerMonth: this.state.monthlyIncome,
            purpose: this.state.purpose,
            organizationalUnitPropertyLeaseholder: null,
        };

        let legalDocument = {
            legalDocumentType: this.state.documentType ? { id: this.state.documentType } : null,
            comment: this.state.documentComment,
            date: this.state.documentDate.getTime(),
            documentNumber: this.state.documentNumber
        };

        if (this.state.requestMode === 'add') {
            if (this.state.hasLegalDocument) {
                axios.post('/assets/legal-documents/', { ...legalDocument })
                    .then(documentRes => {
                        leaseRequest = { ...leaseRequest, legalDocument: { id: documentRes.data.id } };
                        axios.post('/assets/leases/', { ...leaseRequest })
                            .then(res => {
                                if (this.state.showFiltersOnButton) {
                                    this.getFilteredLeases(this.state.activePage - 1, this.state.resultsPerPage);
                                } else {
                                    this.getLeases(this.state.activePage - 1, this.state.resultsPerPage);
                                }
                                toast('Zahtjev uspješno poslan!');
                                this.setState({ requestMode: null });
                                this.resetValues();
                            })
                            .catch(err => {
                                console.log(err);
                                toast('Došlo je do greške dodavanja zakupca!');
                            });
                    })
                    .catch(error => {
                        axios.post('/assets/leases/', { ...leaseRequest })
                            .then(res => {
                                this.getLeases(this.state.activePage - 1, this.state.resultsPerPage);
                                toast('Zahtjev uspješno poslan!');
                                this.setState({ requestMode: null });
                                this.resetValues();
                            })
                            .catch(err => {
                                console.log(err);
                                toast('Došlo je do greške dodavanja pravnog dokumenta!');
                            });
                    });
            } else {
                console.log(leaseRequest);
                axios.post('/assets/leases/', { ...leaseRequest })
                    .then(res => {
                        if (this.state.showFiltersOnButton) {
                            this.getFilteredLeases(this.state.activePage - 1, this.state.resultsPerPage);
                        } else {
                            this.getLeases(this.state.activePage - 1, this.state.resultsPerPage);
                        }
                        toast('Zahtjev uspješno poslan!');
                        this.setState({ requestMode: null });
                        this.resetValues();
                    })
                    .catch(err => {
                        console.log(err);
                        toast('Došlo je do greške dodavanja zakupca!');
                    });
            }
        } else if (this.state.requestMode === 'edit') {
            let legalDocumentPut = {
                ...legalDocument,
                id: this.state.documentId,
                optLock: this.state.documentOptLock,
            };

            if (this.state.documentId === null) {
                if (this.state.hasLegalDocument) {
                    axios.post('/assets/legal-documents/', { ...legalDocument })
                        .then(documentRes => {
                            this.putLease(leaseRequest, documentRes.data.id);
                        })
                        .catch(err => {
                            this.putLease(leaseRequest, null);
                        });
                } else {
                    this.putLease(leaseRequest, null);
                }
            } else {
                axios.put('/assets/legal-documents/', { ...legalDocumentPut });
                this.putLease(leaseRequest, legalDocumentPut.id);
            }
        }
    }

    putLease(leaseRequest, legalDocumentId) {
        const leaseRequestPut = {
            ...leaseRequest,
            id: this.state.leaseId,
            optLock: this.state.leaseOptLock,
            legalDocument: legalDocumentId && this.state.hasLegalDocument ? { id: legalDocumentId } : null
        };

        console.log(leaseRequestPut);

        axios.put('/assets/leases/', { ...leaseRequestPut })
            .then(res => {
                if (this.state.showFiltersOnButton) {
                    this.getFilteredLeases(this.state.activePage - 1, this.state.resultsPerPage);
                } else {
                    this.getLeases(this.state.activePage - 1, this.state.resultsPerPage);
                }
                toast('Zahtjev uspješno uređen!');
                this.setState({ requestMode: null });
                this.resetValues();
            })
            .catch(err => {
                console.log(err);
                toast('Došlo je do greške uređivanja zakupa!');
            });
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value !== '' ? value : null
        });
    }

    handleToggleLegalDocumentChange() {
        this.setState({
            hasLegalDocument: !this.state.hasLegalDocument,
        });
    }

    handleLeaseholderInputChange(event, { name, value }) {
        const leaseholder = this.state.leaseholders.find((el) => el.id === value);
        const organizationalUnit = leaseholder ? leaseholder.organizationalUnit.id : null;
        console.log(organizationalUnit);

        this.setState({
            [name]: value,
            leaseholderSelected: organizationalUnit
        });
    }

    getProperties() {
        return this.state.leaseholderSelected ?
            this.state.properties.filter((el) => (el.organizationalUnit.id === this.state.leaseholderSelected))
            : this.state.properties;
    }

    switchToDetails(lease) {
        console.log(lease);
        if (lease !== null) {
            this.setState({
                details: true,
                leaseObject: lease,
            });
        }
    }

    switchToTable() {
        this.setState({
            leaseObject: null,
            details: false,
        });
    }

    handlePageChange(e, { activePage }) {
        console.log('Page changed: ', activePage);

        if (activePage === this.state.activePage) {
            return;
        }

        if (this.state.showFiltersOnButton) {
            this.getFilteredLeases(activePage - 1, this.state.resultsPerPage);
        } else {
            this.getLeases(activePage - 1, this.state.resultsPerPage);
        }
    }

    handleResultsPerPageChange(e, { value }) {
        if (this.state.showFiltersOnButton) {
            this.getFilteredLeases(0, value);
            return;
        }

        this.getLeases(0, value);
    }

    render() {
        const {
            details, leaseObject, fieldName, direction, activeRole,
        } = this.state;
        if (this.state.error) return <div>Greška</div>;
        if (this.state.loading) return <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>;
        const properties = this.getProperties();
        const leases = this.getDataToRender();
        const organizationalUnitsPrivilege = checkOrganizationalUnitsPrivilege(activeRole);
        const writePrivilege = checkWritePrivilege(activeRole);

        if (details) {
            return (<LeasesDetails
                lease={leaseObject}
                switchToTable={this.switchToTable}
            />);
        }
        return (
            <div>
                <Header as="h1">Zakupi</Header>

                {(this.state.requestMode != null) &&
                    <Segment.Group raised>
                        <Segment raised>
                            <Header as="h3">
                                {this.state.requestMode === 'add' ? 'Dodavanje novog zakupa' : 'Uređivanje zakupa'}
                                <Header style={IconHeader} floated="right" >
                                    {writePrivilege &&
                                    <Radio
                                        toggle
                                        label="Pravni dokument"
                                        name="hasLegalDocument"
                                        checked={this.state.hasLegalDocument === true}
                                        onChange={this.handleToggleLegalDocumentChange}
                                    />

                                    }
                                </Header>
                            </Header>
                        </Segment>
                        <Segment raised clearing>
                            <Form noValidate>
                                <Form.Group widths="4">
                                    <Form.Dropdown
                                        clearable
                                        label="Zakupac"
                                        value={this.state.leaseholder}
                                        options={this.state.leaseholders}
                                        name="leaseholder"
                                        placeholder="Izaberite zakupca"
                                        onChange={this.handleLeaseholderInputChange}
                                        search
                                        fluid
                                        disabled={this.state.requestMode === 'edit'}
                                        required
                                        selection
                                        error={this.state.leaseholderError}
                                    />

                                    <Form.Dropdown
                                        clearable
                                        label="Imovina"
                                        value={this.state.property}
                                        options={properties}
                                        name="property"
                                        placeholder="Izaberite imovinu"
                                        onChange={this.handleInputChange}
                                        search
                                        fluid
                                        disabled={this.state.requestMode === 'edit'}
                                        required
                                        selection
                                        error={this.state.propertyError}
                                    />

                                    <Form.Field
                                        label="Namjena"
                                        control={Input}
                                        name="purpose"
                                        value={this.state.purpose}
                                        onChange={this.handleInputChange}
                                        placeholder="Unesite namjenu zakupa"
                                    />

                                    <Form.Field
                                        label="Napomena"
                                        control={Input}
                                        name="comment"
                                        value={this.state.comment}
                                        onChange={this.handleInputChange}
                                        placeholder="Unesite napomenu"
                                    />
                                </Form.Group>
                                <Form.Group widths="4">
                                    <Form.Field
                                        control={DateTimePicker}
                                        label="Datum početka"
                                        format="DD.MM.YYYY."
                                        parse={str => { let parts = str.split('.'); return new Date(parts[2], parts[1] - 1, parts[0]); }}
                                        time={false}
                                        max={this.state.endDatePicked ? this.state.endDate : new Date(2099, 11, 31)}
                                        onChange={(e) => { if (e <= this.state.endDate) this.setState({ startDate: e, startDatePicked: true }); console.log(this.state.startDate); }}
                                        value={this.state.startDate}
                                        style={{ borderWidth: '0px' }}
                                        required
                                        error={this.state.startDateError}
                                    />

                                    <Form.Field
                                        control={DateTimePicker}
                                        label="Datum kraja"
                                        format="DD.MM.YYYY."
                                        parse={str => { let parts = str.split('.'); return new Date(parts[2], parts[1] - 1, parts[0]); }}
                                        time={false}
                                        min={this.state.startDatePicked ? this.state.startDate : new Date(1900, 0, 1)}
                                        onChange={(e) => { if (e >= this.state.startDate) this.setState({ endDate: e, endDatePicked: true }); console.log(this.state.startDate); }}
                                        value={this.state.endDate}
                                        style={{ borderWidth: '0px' }}
                                        required
                                        error={this.state.endDateError}
                                    />
                                    <Form.Field
                                        label="Mjesečni prihodi (BAM)"
                                        type="number"
                                        control={Input}
                                        name="monthlyIncome"
                                        value={this.state.monthlyIncome}
                                        onChange={this.handleInputChange}
                                        placeholder="Unesite mjesečna primanja"
                                        required
                                        error={this.state.monthlyIncomeError}
                                    />
                                </Form.Group>
                                <Divider />

                                {this.state.hasLegalDocument &&
                                    <Form.Group widths="4">
                                        <Form.Dropdown
                                            clearable
                                            label="Tip dokumenta"
                                            value={this.state.documentType}
                                            options={this.state.legalDocumentTypes}
                                            name="documentType"
                                            placeholder="Izaberite tip dokumenta"
                                            onChange={this.handleInputChange}
                                            search
                                            fluid
                                            selection
                                            required
                                            error={this.state.documentTypeError}
                                        />

                                        <Form.Field
                                            control={DateTimePicker}
                                            label="Datum izdavanje dokumenta"
                                            format="DD.MM.YYYY."
                                            parse={str => { let parts = str.split('.'); return new Date(parts[2], parts[1] - 1, parts[0]); }}
                                            time={false}
                                            onChange={(e) => { this.setState({ documentDate: e }); }}
                                            value={this.state.documentDate}
                                            style={{ borderWidth: '0px' }}
                                            required
                                            error={this.state.documentDateError}
                                        />

                                        <Form.Field
                                            label="Broj dokumenta"
                                            control={Input}
                                            name="documentNumber"
                                            value={this.state.documentNumber}
                                            onChange={this.handleInputChange}
                                            placeholder="Unesite broj dokumenta"
                                            required
                                            error={this.state.documentNumberError}
                                        />

                                        <Form.Field
                                            label="Napomena"
                                            control={Input}
                                            name="documentComment"
                                            value={this.state.documentComment}
                                            onChange={this.handleInputChange}
                                            placeholder="Unesite napomenu"
                                        />
                                    </Form.Group>
                                }

                                <Button
                                    floated="right"
                                    onClick={this.cancelRequest}
                                    basic
                                    color="blue"
                                >Odustani
                                </Button>
                                <Button
                                    floated="right"
                                    color="blue"
                                    onClick={
                                        () => {
                                            this.sendLeaseRequest();
                                        }
                                    }
                                >
                                    {this.state.requestMode === 'add' ? 'Pošalji' : 'Uredi'}
                                </Button>
                            </Form>
                        </Segment>
                    </Segment.Group>
                }
                <Segment.Group raised>
                    <Segment>
                        <Header as="h3">
                        Spisak zakupa

                            <Header style={IconHeader} floated="right" >
                                {writePrivilege &&
                                <Button
                                    floated="right"
                                    icon
                                    labelPosition="right"
                                    primary
                                    size="small"
                                    style={FiltersOnStyle}
                                    onClick={this.activateAddRequest}
                                >
                                    <Icon className="add" />
                                    Dodavanje novog zakupa
                                </Button>

                                }
                            </Header>


                        </Header>
                    </Segment>
                    {this.state.showFilterMode &&
                    <LeasesFilter
                        onFilterData={this.onFilterData}
                        lookups={this.state.lookups}
                        leaseholders={this.state.leaseholders}
                        properties={this.state.properties}
                        organizationalUnits={this.state.organizationalUnits}
                        organizationalUnitsPrivilege={organizationalUnitsPrivilege}
                        cancelFilter={this.activateFilter}
                        legalDocumentTypes={this.state.legalDocumentTypes}
                    />
                    }
                    <Segment>
                        {writePrivilege &&
                            <React.Fragment>
                                <Header style={IconHeader} floated="right" >
                                    {this.state.showFiltersOnButton &&
                                    <Button
                                        floated="left"
                                        icon
                                        labelPosition="right"
                                        color="orange"
                                        size="small"
                                        style={FiltersOnStyle}
                                    >
                                        <Icon className="remove" onClick={this.filtersOff} />
                                        Filter uključen
                                    </Button>}
                                    <Icon />
                                    <Popup
                                        trigger={<Icon link circular basic floated="right" name="filter" onClick={this.activateFilter} />}
                                        content="Filtriraj podatke"
                                        hideOnScroll
                                        position="top center"
                                    />
                                </Header>
                                {/* <ResultsPerPageDropdown */}
                                {/*    resultsPerPage={this.state.resultsPerPage} */}
                                {/*    onResultsPerPageChange={this.handleResultsPerPageChange} */}
                                {/* /> */}

                            </React.Fragment>
                        }
                        {leases.length ?
                            <LeasesTable
                                leases={leases}
                                activateEditRequest={this.activateEditRequest}
                                writePrivilege={writePrivilege}
                                switchToDetails={this.switchToDetails}
                                getSortedLeases={this.getSortedLeases}
                                fieldName={fieldName}
                                direction={direction}
                            /> :
                            <p>Nema podataka.</p>
                        }
                    </Segment>
                    {leases.length > 0 && <PaginationSegment
                        activePage={this.state.activePage}
                        totalPages={this.state.totalPages}
                        onPageChange={this.handlePageChange}
                    />}
                    <ToastContainer hideProgressBar />
                </Segment.Group>
            </div>
        );
    }
}


export default Leases;



// WEBPACK FOOTER //
// ./src/views/Assets/Leases.js